import { render, staticRenderFns } from "./PublishCard.vue?vue&type=template&id=45253cac"
import script from "./PublishCard.vue?vue&type=script&lang=js"
export * from "./PublishCard.vue?vue&type=script&lang=js"
import style0 from "./PublishCard.vue?vue&type=style&index=0&id=45253cac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports